module.exports = __webpack_public_path__ + "static/media/img-producto-aluminio.c324c9eb.png";